<template>
	<section>
		<div class="section-header" @click="$emit('toggle-open')" :class="{opened: open}">
			<h2>{{ title }}</h2>
			<ChevronUpIcon class="icon" v-if="open"/>
			<ChevronDownIcon class="icon" v-else/>
		</div>
		<div class="section-content" v-if="open">
			<div class="content">
				<p class="specification-line">
					<span>Uitvoering</span>
					<span>{{
							empty(appointment.date) ? "onbekend"
								: reverseDate(appointment.date)
						}}
					</span>
				</p>
				<p class="specification-line">
					<span>Uitvoerende ploeg</span>
					<span> {{
							empty(appointment.teamLeader) ? "onbekend"
								: empty(appointment.teamLeader.display_name) ? appointment.teamLeader.username
									: appointment.teamLeader.display_name
						}}
					</span>
				</p>
				<p class="specification-line" v-if="empty(appointment.historicTeamMembers) || appointment.historicTeamMembers.length === 0">
					<span>Monteurs</span>
					<span>onbekend</span>
				</p>
				<p class="specification-line" v-for="(member, index) of appointment.historicTeamMembers">
					<span>{{ index === 0 ? "Monteurs" : "" }}</span>
					<span>{{ empty(member.display_name) ? member.username : member.display_name }}</span>
				</p>
			</div>

			<div class="question-section" v-if="finalPhotoSection != null">
				<div
					class="question stacked"
					v-for="question in finalPhotoSection.questions"
					:key="question.id"
				>
					<div
						class="stacked-inner"
					>
						<QuestionSingleFileUpload
							v-if="question.type === 'FILE'"
							v-model="question.answers[0].value"
							:title="question.name"
							:type="question.config.type"
							:companyId="companyId"
							:disabled="true"
							:show-uploaded-time="question.config.hasOwnProperty('saveTimestamp') && question.config.saveTimestamp === true"
							ref="fileUpload"
						></QuestionSingleFileUpload>
					</div>
				</div>
			</div>

			<div class="section-header">
				<h2>{{ finalCheckSection.name }}</h2>
			</div>

			<div class="question-section">
				<div
					class="question"
					v-for="(question, index) in finalCheckSection.questions"
					:key="question.id"
				>
					<div class="question-inner">
						<label
							v-if="['SIGNATURE', 'TEXT', 'RADIO-KMK', 'FILE'].includes(question.type) === false && (question.config.hasOwnProperty('labelHidden') === false || question.config.hasOwnProperty('labelHidden')  === true && question.config.labelHidden === false)  " :for="question.id"
						>{{
								question.name
							}}
						</label>
						<input
							v-if="question.type === 'NUMBER'"
							type="number"
							:placeholder="question.config.placeholder"
							:id="question.id"
							:disabled="true"
							v-model="question.answers[0].value"
							:class=" question.config.hasOwnProperty('labelHidden')  === true && question.config.labelHidden === true ? 'no-label' : ''"
						/>
						<QuestionEmailInput
							v-if="question.type === 'EMAIL'"
							type="email"
							:config="question.config"
							:variables="variables"
							:id="question.id"
							:disabled="true"
							v-model="question.answers[0].value"
						/>
						<textarea
							v-if="question.type === 'TEXT'"
							:placeholder="question.config.placeholder"
							:id="question.id"
							:disabled="true"
							v-model="question.answers[0].text_value"
							rows="5"
						>
						</textarea>
						<select
							v-if="question.type === 'SELECT'" :id="question.id" v-model="question.answers[0].value" :disabled="true"

						>
							<option disabled :value="null">{{ question.config.placeholder }}</option>
							<option
								v-for="option in question.config.options" :key="option" :value="option"
							>{{ option }}
							</option>
						</select>
						<QuestionDynamicSelect
							v-if="question.type === 'DYNAMIC-SELECT'"
							:id="question.id"
							:config="question.config"
							:variables="variables"
							:disabled="true"
							v-model="question.answers[0].value"
						></QuestionDynamicSelect>
						<QuestionFileUpload
							v-if="question.type === 'FOLDER'"
							v-model="question.answers[0].value"
							:title="question.config.placeholder"
							:type="question.config.type"
							:companyId="companyId"
							:multiple="true"
							:disabled="true"
							ref="fileUpload"
						></QuestionFileUpload>
						<QuestionKmkInput
							v-if="question.type === 'RADIO-KMK'"
							:answer="question.answers[0]"
							:question="question"
							:disabled="true"
							:config="question.config"
						/>
						<div v-if="question.type === 'RADIO'" class="radio-options">
							<div v-for="(option, index2) in question.config.options" class="option">
								<input
									:id="index + '.' + index2"
									type="radio"
									:value="option"
									v-model="question.answers[0].value"
									:disabled="true"
									:name="index"
								>
								<label :for="index + '.' + index2">{{ option }}</label>
							</div>
						</div>
						<QuestionSignatureInput
							v-if="question.type === 'SIGNATURE'"
							:company-id="companyId"
							:title="question.name"
							:type="question.config.type"
							:disabled="true"
							v-model="question.answers[0].file_id"
							ref="fileUpload"
							class="signature-container"
						></QuestionSignatureInput>
					</div>

				</div>
			</div>
















			<div class="button-container">
				<Button class="next-button" v-if="showNextButton" @click="$emit('open-next')" :disabled="isLoading">
					<ArrowRightIcon v-if="!isLoading" />
					<LoadingIndicator v-else
									  style="height: 16px;"/>
					Volgende
				</Button>
			</div>
		</div>
	</section>
</template>

<script>

import Button from "@/components/Button";
import LoadingIndicator from "@/components/LoadingIndicator";
import QuestionDynamicSelect from "@/components/QuestionDynamicSelect.vue";
import QuestionEmailInput from "@/components/QuestionEmailInput.vue";
import QuestionFileUpload from "@/components/QuestionFileUpload.vue";
import QuestionKmkInput from "@/components/QuestionKmkInput.vue";
import QuestionSignatureInput from "@/components/QuestionSignatureInput.vue";
import QuestionSingleFileUpload from "@/components/QuestionSingleFileUpload.vue";
import {ArrowRightIcon, ChevronDownIcon, ChevronUpIcon} from "vue-feather-icons";
import {mapState} from "vuex";

export default {
	components: {
		QuestionSingleFileUpload,
		QuestionKmkInput,
		QuestionDynamicSelect,
		QuestionSignatureInput,
		QuestionFileUpload,
		QuestionEmailInput,
		ChevronDownIcon,
		ChevronUpIcon,
		Button,
		ArrowRightIcon,
		LoadingIndicator
	},
	props: {
		title: String,
		open: Boolean,
		showNextButton: Boolean,
		showCancelButton: false,
		showExtraButton: false,
		appointment: Object,
		companyId: Number,
		variables: Object
	},

	data() {
		return {
			finalPhotoSection: null,
			finalCheckSection: null
		};
	},
	computed: {
		...mapState({
			isLoading: "loading"
		})
	},
	mounted() {
		this.finalPhotoSection = this.appointment.questionnaire.question_groups.find(group => group.constant === "OPLEVERING_PHOTOS");
		this.finalCheckSection = this.appointment.questionnaire.question_groups.find(group => group.constant === "EINDCONTROLE");
		if (this.finalPhotoSection != null) {
			this.finalPhotoSection = this.parseQuestions(this.finalPhotoSection);
		}
		if (this.finalCheckSection != null) {
			this.finalCheckSection = this.parseQuestions(this.finalCheckSection);
		}
	},
	methods: {
		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},
		reverseDate(date) {
			return date.split("-").reverse().join("-");
		},
		parseQuestions(section) {
			section.questions = section.questions.map(question => {
				question.config = JSON.parse(question.config);
				if (question.type === "RADIO-KMK") {
					question.answers[0].text_value = JSON.parse(question.answers[0].text_value);
				}
				return question;
			});
			return section;
		},
	}
};
</script>
<style lang="scss" scoped>
.specification-line {
	display: flex;
	justify-content: space-between;
	margin: 16px 0;
	font-size: 18px;
	font-weight: 500;
}

section {
	background: #f7f9fa;
}

.section-header {
	margin: 0 0 0 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	h2 {
		font-weight: 400;
	}

	&.opened {
		h2 {
			text-transform: uppercase;
			font-weight: 600;
		}
	}

	.icon {
		height: 48px;
		width: 48px;
	}
}

.section-content {
	margin: 0 8px;

	.button-container {
		display: flex;

		.cancel-button {
			margin: 8px 0 8px 0;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 5px 16px;
			background-color: #E53935;
			color: white;
			border: none;
			border-radius: 4px;
			font-weight: bold;
			height: 36px;
			min-width: 130px;
		}

		.extra-button {
			margin: 8px 0 8px 16px;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 5px 16px;
			background-color: #e8833a;
			color: white;
			border: none;
			border-radius: 4px;
			font-weight: bold;
			height: 36px;
			min-width: 130px;
		}

		.next-button {
			align-self: flex-end;
			margin: 8px 0 8px auto;
			display: flex;
			align-items: center;
			justify-content: center;
			text-align: center;
			padding: 5px 16px;
			background-color: #35a5a4;
			color: white;
			border: none;
			border-radius: 4px;
			font-weight: bold;
			height: 36px;
			min-width: 130px;


			svg {
				width: 16px;
				height: 16px;
				margin-right: 8px;
			}
		}
	}
}

.question {
	width: 100%;
	min-width: 100%;

	&.stacked {
		width: 50%;
		min-width: 50%;

		&:only-child {
			width: 100%;
			min-width: 100%;
		}

		.stacked-inner {
			margin: 8px;

			input {
				margin-top: 8px;
				width: 100%;
			}
		}
	}

	.question-inner {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 24px;
	}

	label {
		font-size: 1.2rem;
		font-weight: 500;
		min-width: 200px;
		max-width: 60%;
	}

	input, select {
		border: 2px solid #ced6dd;
		padding: 6px;
		border-radius: 5px;
		height: 36px;
		box-sizing: border-box;
		width: 30%;
		background: #ffffff;
		min-width: 16px;

		&.no-label {
			width: 100%;
		}

		&[type=email] {
			width: 60%;
		}

		&[type=radio] {
			width: 24px;
		}
	}

	textarea {
		border: 2px solid #ced6dd;
		padding: 6px;
		border-radius: 5px;
		box-sizing: border-box;
		width: 100%;
		background: #ffffff;
	}

	button {
		height: 36px;
		border: 2px solid #35a5a4;
		border-radius: 5px;
		color: #35a5a4;
		background: #ffffff;
		align-items: center;
		display: flex;
		min-width: 130px;
		justify-content: center;
		gap: 8px;
	}

	.radio-options {
		//min-width: 50%;
		display: flex;
		justify-content: flex-end;

		.option {
			display: flex;
			align-items: center;

			label {
				min-width: unset;
				white-space: nowrap;
				padding: 8px 16px 8px 8px;
				font-weight: normal;
			}
		}
	}
}

.question-section {
	display: flex;
	overflow: hidden;
	flex-wrap: wrap;
}
</style>
